module.exports = __webpack_public_path__ + "static/media/app-store-w.c0011daf.png";